import { useCallback, useEffect, useRef, useState } from 'react';
import { viewerHeaders } from '../utils/viewerAccess';
const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://peekr-production.up.railway.app';
export default function WalkthroughMedia({ content, roomCode }) {
  const [path, setPath] = useState(null); const [busy, setBusy] = useState(false); const [error, setError] = useState(null);
  const version = useRef(0);
  const open = useCallback(async () => {
    const current = ++version.current; setBusy(true); setError(null);
    try {
      const response = await fetch(SERVER_URL + '/walkthrough/' + roomCode + '/access', { method: 'POST', headers: await viewerHeaders(roomCode), body: JSON.stringify({ itemId: content.itemId, page: content.page || 1 }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Could not open this media.');
      if (current === version.current) setPath(SERVER_URL + data.playbackPath);
    } catch (e) { if (current === version.current) setError(e.message); }
    finally { if (current === version.current) setBusy(false); }
  }, [roomCode, content.itemId, content.page]);
  useEffect(() => {
    const generation = version;
    setPath(null); setError(null); setBusy(false);
    if (content.kind === 'pdf') open();
    return () => { generation.current++; };
  }, [content.kind, open]);
  return <div className="content-frame" style={{ padding: 16 }}>
    <h2>{content.title}</h2>
    {content.kind === 'pdf' && <p>Page {content.page} of {content.pages} · Your host controls the walkthrough.</p>}
    {busy && <p role="status">Preparing secure playback…</p>}
    {error && <p role="alert">{error}</p>}
    {!path && <button className="btn" disabled={busy} onClick={open}>{content.kind === 'video' ? 'Play property video' : 'Retry document'}</button>}
    {path && (content.kind === 'video' ? <><video key={path} src={path} controls autoPlay playsInline onError={() => { setPath(null); setError('Playback interrupted. Tap Play to retry.'); }} /><p>Tap the video’s Play control if it does not start automatically.</p></> : <img src={path} alt={'Document page ' + content.page} onError={() => { setPath(null); setError('Page could not load. Please retry.'); }} />)}
  </div>;
}
